export default __webpack_public_path__ + "static/media/1954.725bd68f.png";